import Stepper from '../../../Stepper.jsx';

const QuantityPicker = ({ value, capacity, settings, onChange }) => {
    if (capacity <= 1 || settings?.hideQuantity) {
        return null;
    }
    return (
        <div>
            <div className="mt-4 input-label">
                {settings?.quantityLabel || 'Quantity'}
            </div>
            <div className="flex">
                <Stepper
                    value={value}
                    onChange={value =>
                        onChange(Math.min(capacity, Math.max(0, value)))
                    }
                />
            </div>
        </div>
    );
};

export default QuantityPicker;
